import { Injectable } from '@angular/core';

// keep the same class name so DI tokens match
@Injectable({ providedIn: 'root' })
export class IdentityUserDelegationServiceStub {
    // every method returns a resolved promise / empty array
    getList = async () => [];
    create = async () => void 0;
    delete = async () => void 0;
    // add others only if the compiler complains
}